import React, { useState, useEffect } from 'react';
import { db } from '../firebase/config';
import {
  collection,
  addDoc,
  doc,
  onSnapshot,
  updateDoc,
  deleteDoc,
  arrayUnion,
  arrayRemove,
  getDoc
} from "firebase/firestore";

import { Client, Storage, ID } from 'appwrite';

/* ================= APPWRITE CONFIG ================= */

const client = new Client()
  .setEndpoint('https://fra.cloud.appwrite.io/v1')
  .setProject('68dd248c001d5e1cc828');

const storage = new Storage(client);
const storageID = '699dc732002329ddcf56';

/* ================= HARDCODED PASSWORDS ================= */

const ADMIN_PASSWORDS = [
  "AMEO@1320",
  "omesh123",
  "root@"
];

const Admin = () => {

  const [authorized, setAuthorized] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");

  const [titles, setTitles] = useState([]);
  const [selectedTitleId, setSelectedTitleId] = useState("");

  const [newTitle, setNewTitle] = useState({
    title: "",
    category: "",
    content: "",
    date: ""
  });

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [siteViews, setSiteViews] = useState(0);
  const [refreshing, setRefreshing] = useState(false);

  /* ================= LOGIN ================= */

  const handleLogin = () => {
    if (ADMIN_PASSWORDS.includes(passwordInput)) {
      setAuthorized(true);
    } else {
      alert("WRONG PASSWORD");
    }
  };

  /* ================= FETCH TITLES ================= */

  useEffect(() => {
    if (!authorized) return;

    const unsub = onSnapshot(collection(db, "photography"), (snap) => {
      setTitles(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });

    return () => unsub();
  }, [authorized]);

  /* ================= FETCH VIEWS ================= */

  useEffect(() => {
    if (!authorized) return;

    const statsRef = doc(db, "stats", "siteMetrics");

    const unsub = onSnapshot(statsRef, (docSnap) => {
      if (docSnap.exists()) {
        setSiteViews(docSnap.data().views || 0);
      } else {
        setSiteViews(0);
      }
    });

    return () => unsub();
  }, [authorized]);

  const handleRefreshViews = async () => {
    setRefreshing(true);
    const statsRef = doc(db, "stats", "siteMetrics");
    const snap = await getDoc(statsRef);
    if (snap.exists()) {
      setSiteViews(snap.data().views || 0);
    }
    setRefreshing(false);
  };

  /* ================= CREATE TITLE ================= */

  const handleCreateTitle = async (e) => {
    e.preventDefault();
    if (!newTitle.title) return alert("TITLE REQUIRED");

    await addDoc(collection(db, "photography"), {
      ...newTitle,
      images: [],
      fileIds: [],
      createdAt: new Date()
    });

    alert("TITLE CREATED");
    setNewTitle({ title: "", category: "", content: "", date: "" });
  };

  /* ================= DELETE TITLE ================= */

  const handleDeleteTitle = async (titleId, fileIds = []) => {
    if (!window.confirm("DELETE THIS TITLE?")) return;

    try {
      // delete all files from appwrite
      for (let id of fileIds) {
        await storage.deleteFile(storageID, id);
      }

      // delete firestore doc
      await deleteDoc(doc(db, "photography", titleId));

      alert("TITLE DELETED");
    } catch (err) {
      alert(err.message);
    }
  };

  /* ================= ADD IMAGE ================= */

  const handleAddImage = async (e) => {
    e.preventDefault();

    if (!selectedTitleId) return alert("SELECT A TITLE");
    if (!file) return alert("SELECT AN IMAGE");

    setLoading(true);

    try {
      const fileId = ID.unique();
      await storage.createFile(storageID, fileId, file);

      const url = `https://fra.cloud.appwrite.io/v1/storage/buckets/${storageID}/files/${fileId}/view?project=68dd248c001d5e1cc828`;

      const docRef = doc(db, "photography", selectedTitleId);

      await updateDoc(docRef, {
        images: arrayUnion(url),
        fileIds: arrayUnion(fileId)
      });

      alert("IMAGE ADDED");
      setFile(null);
      e.target.reset();

    } catch (err) {
      alert(err.message);
    }

    setLoading(false);
  };

  /* ================= DELETE IMAGE ================= */

  const handleDeleteImage = async (titleId, imageUrl, fileId) => {
    if (!window.confirm("DELETE THIS IMAGE?")) return;

    try {
      await storage.deleteFile(storageID, fileId);

      const docRef = doc(db, "photography", titleId);

      await updateDoc(docRef, {
        images: arrayRemove(imageUrl),
        fileIds: arrayRemove(fileId)
      });

      alert("IMAGE DELETED");
    } catch (err) {
      alert(err.message);
    }
  };

  /* ================= STYLES ================= */

  const wrapper = {
    background: "#3B44F6",
    minHeight: "100vh",
    padding: "40px",
    fontFamily: '"Arial Black", sans-serif'
  };

  const box = {
    background: "#fff",
    padding: "30px",
    marginBottom: "40px",
    border: "6px solid #000",
    boxShadow: "10px 10px 0px #000"
  };

  const input = {
    width: "100%",
    padding: "12px",
    marginBottom: "15px",
    border: "4px solid #000",
    fontWeight: "900"
  };

  const button = {
    padding: "10px",
    background: "#FF3131",
    color: "#fff",
    border: "3px solid #000",
    fontWeight: "900",
    cursor: "pointer",
    marginTop: "10px"
  };

  if (!authorized) {
    return (
      <div style={wrapper}>
        <div style={box}>
          <h2 style={{color:'black'}}>ENTER ADMIN PASSWORD</h2>
          <input
            type="password"
            style={input}
            value={passwordInput}
            onChange={(e) => setPasswordInput(e.target.value)}
          />
          <button style={button} onClick={handleLogin}>
            LOGIN
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={wrapper}>

      <h1 style={{color:"#fff"}}>ADMIN TERMINAL</h1>

      {/* SITE VIEWS */}
      <div style={box}>
        <h2 style={{color:'black'}}>TOTAL SITE VIEWS</h2>
        <h1 style={{color:'black'}}>{siteViews}</h1>
        <button onClick={handleRefreshViews} style={button}>
          {refreshing ? "REFRESHING..." : "REFRESH"}
        </button>
      </div>

      {/* CREATE TITLE */}
      <div style={box}>
        <h2>CREATE TITLE</h2>
        <form onSubmit={handleCreateTitle}>
          <input required style={input} placeholder="TITLE"
            value={newTitle.title}
            onChange={e => setNewTitle({...newTitle, title:e.target.value})}
          />
          <input required style={input} placeholder="LOCATION"
            value={newTitle.category}
            onChange={e => setNewTitle({...newTitle, category:e.target.value})}
          />
          <input required type="date" style={input}
            value={newTitle.date}
            onChange={e => setNewTitle({...newTitle, date:e.target.value})}
          />
          <textarea required style={{...input, height:"80px"}}
            placeholder="STORY"
            value={newTitle.content}
            onChange={e => setNewTitle({...newTitle, content:e.target.value})}
          />
          <button style={button}>CREATE</button>
        </form>
      </div>

      {/* ADD IMAGE */}
      <div style={box}>
        <h2>ADD IMAGE</h2>
        <form onSubmit={handleAddImage}>
          <select required style={input}
            value={selectedTitleId}
            onChange={e => setSelectedTitleId(e.target.value)}
          >
            <option value="">SELECT TITLE</option>
            {titles.map(t => (
              <option key={t.id} value={t.id}>{t.title}</option>
            ))}
          </select>

          <input required type="file" style={input}
            onChange={e => setFile(e.target.files[0])}
          />

          <button disabled={loading} style={button}>
            {loading ? "UPLOADING..." : "ADD IMAGE"}
          </button>
        </form>
      </div>

      {/* TITLE LIST WITH DELETE OPTIONS */}
      <div style={box}>
        <h2>MANAGE TITLES</h2>

        {titles.map(title => (
          <div key={title.id} style={{marginBottom:"30px", borderBottom:"3px solid black", paddingBottom:"20px"}}>
            <h3 style={{color:'black'}}>{title.title}</h3>

            <button
              onClick={() => handleDeleteTitle(title.id, title.fileIds)}
              style={{...button, background:"#000"}}
            >
              DELETE TITLE
            </button>

            <div style={{marginTop:"15px"}}>
              {title.images && title.images.map((img, index) => (
                <div key={index} style={{marginBottom:"15px"}}>
                  <img src={img} alt="" style={{width:"150px"}} />
                  <br />
                  <button
                    onClick={() =>
                      handleDeleteImage(title.id, img, title.fileIds[index])
                    }
                    style={{...button, background:"#333"}}
                  >
                    DELETE IMAGE
                  </button>
                </div>
              ))}
            </div>
          </div>
        ))}

      </div>

    </div>
  );
};

export default Admin;